import * as React from 'react';

import '../../styles/App.css';
import _gConstants from '../../configuration/constants.json';
import errorBannerImgDesktop from '../../assets/img/variante-NIL-desktop.jpg';
import errorBannerImgMobile from '../../assets/img/variante-NIL-mobile.jpg';
import acceptBannerImgDesktop from '../../assets/img/variante3-desktop.jpg';
import acceptBannerImgMobile from '../../assets/img/variante3-mobile.jpg';
import rejectBannerImgDesktop from '../../assets/img/variante1-desktop.jpg';
import rejectBannerImgMobile from '../../assets/img/variante1-mobile.jpg';

export default function Header(props) {
  return (
    <div className="banner">
      <img
        src={props.status===_gConstants.ACCEPT_BANNER_STATUS?acceptBannerImgDesktop:
            (props.status===_gConstants.REJECT_BANNER_STATUS?rejectBannerImgDesktop:errorBannerImgDesktop)}
        className="banner-img desktop"
        alt="banner"
      />
      <img 
        src={props.status===_gConstants.ACCEPT_BANNER_STATUS?acceptBannerImgMobile:
        (props.status===_gConstants.REJECT_BANNER_STATUS?rejectBannerImgMobile:errorBannerImgMobile)}
        className="banner-img mobile" alt="banner" />
    </div>
  )
}